import { OrganizationTraits } from '@neptune/shared/core-organizations-domain';

export const isServiceAccountsEnabled = (traits: OrganizationTraits) => !!traits.serviceAccounts;
